import {createStyles, Link, makeStyles, Paper, Theme, Typography} from '@material-ui/core';
import {useBreadcrumbs} from 'Core/hooks/useBreadcrumbs';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useRouteMatch} from 'react-router-dom';
import {ReducerState} from 'rootReducer';
import {updatefeatureVariables} from 'Core/ducks/featureToggle';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      [theme.breakpoints.up('lg')]: {
        paddingLeft: theme.spacing(8),
        paddingRight: theme.spacing(8),
      },
      [theme.breakpoints.down('md')]: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
    paper: {
      padding: theme.spacing(1),
      margin: theme.spacing(1),
    },
    section: {
      [theme.breakpoints.up('lg')]: {
        width: '50%',
        margin: 'auto',
      },
    },
  })
);

const EnrollMyWay = () => {
  const match = useRouteMatch();
  const {featureVariables} = useSelector((state: ReducerState) => state.featureToggle);
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updatefeatureVariables({...featureVariables, FOOTER_OPEN_DEFAULT: false}));
  }, []);

  useBreadcrumbs('EnrollMyWay Voice Upload', match.url);


  return (
    <div className={classes.root}>
      <div className={classes.section}>
        <Paper className={classes.paper}>
          <Typography variant="h6">EnrollMyWay Voice File Upload</Typography>
          <Typography variant="body1">
            <Link target="_blank" href="https://awdfileportal.allstateatwork.com/AgentVoice/">
              Agent Voice Upload
            </Link>
          </Typography>
        </Paper>
      </div>
    </div>
  );
};

export default EnrollMyWay;
